import i18n from "i18next";
import {
    initReactI18next
} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { syncLanguageDocument } from "./syncLanguageDocument";

i18n.on("languageChanged", syncLanguageDocument);

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "ar",
        react: {
            useSuspense: true
        },
        detection: {
            order: ['localStorage', 'cookie', 'path', 'htmlTag'],
            lookupCookie: 'language',
            caches: ['localStorage'],
        }
    })
    .then(() => {
        syncLanguageDocument(i18n.resolvedLanguage || i18n.language);
    });

export default i18n;